/* Magnavia conversion layer v4 — reveal, Ryze-style countdown, bundle cards, carousel,
   stock/ship urgency, count-up, social toasts, quiz (20s + exit intent), sign-up code reveal.
   Plain JS, no dependencies, reduced-motion aware. */
(function () {
  "use strict";
  var doc = document, win = window, root = doc.documentElement;
  root.classList.add("mv-js");
  var reduced = win.matchMedia && win.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var CFG = win.MV_CONFIG || {};
  var BUNDLE_MODE = "variant";
  var money = function (p) { /* pence -> $x.xx (shop is GBP) */
    var s = (Math.round(p) / 100).toFixed(2);
    var sym = CFG.currencySymbol || "£";
    return sym + s;
  };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var pad = function (n) { return (n < 10 ? "0" : "") + n; };
  var ready = function (fn) { if (doc.readyState !== "loading") fn(); else doc.addEventListener("DOMContentLoaded", fn); };

  /* ------------------------------------------------------------ reveal */
  function initReveal() {
    var sel = ".mv-reveal, .bb-sec .bb-wrap, .bbhr, .quantity-breaks, .bb-receipt, .mv-supports, .ev-guarantee-box, .mv-h2, .mv-chiprow, .mv-cd, .mv-risk, .mv-statement, .bbrv-row, .mv-foot__col, .mv-stats__grid, .mv-faq, .mv-trustrow, .mv-shipline";
    var els = doc.querySelectorAll(sel);
    if (!els.length) return;
    els.forEach(function (e) { e.classList.add("mv-reveal"); });
    if (reduced || !("IntersectionObserver" in win)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("is-in"); io.unobserve(x.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------------ countdown (Ryze) */
  /* One shared per-visitor timer: 15 min. On expiry every instance flips to
     "Need more time? We've extended your discount." and a fresh 10 min starts. */
  var CD_KEY = "mv_cd_v2", CD_FIRST = 15 * 60 * 1000, CD_NEXT = 10 * 60 * 1000;
  function cdState() {
    var s = store.get(CD_KEY), now = Date.now();
    if (!s || !s.end) { s = { end: now + CD_FIRST, ext: 0 }; store.set(CD_KEY, s); }
    return s;
  }
  function initCountdown() {
    var nodes = doc.querySelectorAll("[data-mv-cd]");
    if (!nodes.length) return;
    var s = cdState(), extAt = 0;
    function setExtended(on) {
      nodes.forEach(function (n) {
        n.classList.toggle("is-extended", on);
        var l = n.querySelector("[data-cd-label]"); if (!l) return;
        l.textContent = on ? (n.getAttribute("data-mv-cd-extended") || "Need more time? We've extended your discount.") : (n.getAttribute("data-mv-cd-label") || l.textContent);
      });
    }
    var want = null;
    function paint() {
      var el = sec.querySelector("input[name='id'].product-variant-id") || doc.querySelector("input[name='id'].product-variant-id");
      var id = el && el.value;
      if (id && id !== last) {
        last = id;
        var v = map[id];
        if (v) {
          want = v.featured_image && v.featured_image.src ? v.featured_image.src.split("?")[0] + "?width=300" : null;
          if (img && want) img.alt = v.name || v.title;
          var save = v.compare_at_price > v.price ? Math.round(100 - v.price * 100 / v.compare_at_price) : 0;
          deal.textContent = v.title + (save ? " \u00b7 SAVE " + save + "%" : "");
          deal.hidden = false;
        }
      }
      if (img && want && img.getAttribute("src") !== want) img.setAttribute("src", want);   /* the theme rewrites src on its own variant update */
    }
    paint(); setInterval(paint, 1000);
  }

  /* ---------------------------------------------- bundle cards (mv-bcard) */
  function initBundles() {
    doc.querySelectorAll("[data-mv-bundles]").forEach(function (wrap) {
      var cards = wrap.querySelectorAll(".mv-bcard"), idInput = wrap.querySelector("input[name='id']"),
          btnPrice = wrap.querySelector("[data-mv-atc-price]"), perday = wrap.querySelector("[data-mv-perday]"),
          saveEl = wrap.querySelector("[data-mv-save]"), qtyInput = wrap.querySelector("input[name='quantity'][data-mv-qty]");
      function apply(card, user) {
        cards.forEach(function (c) { c.classList.toggle("is-on", c === card); });
        var r = card.querySelector("input[type=radio]"); if (!r) return; r.checked = true;
        if (idInput) idInput.value = r.value;
        if (qtyInput) qtyInput.value = r.getAttribute("data-qty") || 1;
        if (btnPrice) btnPrice.textContent = money(+r.getAttribute("data-price"));
        if (perday) perday.textContent = r.getAttribute("data-perday") || "";
        if (saveEl) saveEl.textContent = r.getAttribute("data-save") || "";
        wrap.dispatchEvent(new CustomEvent("mv:bundle", { detail: { id: r.value, price: +r.getAttribute("data-price") }, bubbles: true }));
      }
      cards.forEach(function (c) {
        c.addEventListener("click", function () { apply(c, true); });
        c.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); apply(c, true); } });
      });
      var on = wrap.querySelector(".mv-bcard input:checked");
      if (on) apply(on.closest(".mv-bcard")); else if (cards[1]) apply(cards[1]);
    });
  }

  /* ------------------------------------------------------------ carousel */
  function initCarousel() {
    doc.querySelectorAll("[data-mv-car]").forEach(function (car) {
      var track = car.querySelector(".mv-car__track"), slides = car.querySelectorAll(".mv-car__slide"),
          thumbs = car.querySelectorAll(".mv-car__thumb"), prev = car.querySelector(".mv-car__nav--prev"), next = car.querySelector(".mv-car__nav--next");
      if (!track || !slides.length) return;
      var i = 0, n = slides.length, timer, paused = false, autoplay = +(car.getAttribute("data-autoplay") || 0);
      function go(k, smooth) { i = (k + n) % n; track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reduced ? "auto" : "smooth" }); mark(); }
      function mark() { thumbs.forEach(function (t, k) { t.classList.toggle("is-on", k === i); t.setAttribute("aria-current", k === i ? "true" : "false"); }); }
      thumbs.forEach(function (t, k) { t.addEventListener("click", function () { go(k); bump(); }); });
      if (prev) prev.addEventListener("click", function () { go(i - 1); bump(); });
      if (next) next.addEventListener("click", function () { go(i + 1); bump(); });
      var sc; track.addEventListener("scroll", function () { clearTimeout(sc); sc = setTimeout(function () { var k = Math.round(track.scrollLeft / slides[0].offsetWidth); if (k !== i) { i = (k + n) % n; mark(); } }, 80); }, { passive: true });
      function bump() { paused = true; clearTimeout(timer); setTimeout(function () { paused = false; loop(); }, 9000); }
      function loop() { if (!autoplay || reduced) return; clearTimeout(timer); timer = setTimeout(function () { if (!paused && doc.visibilityState === "visible") go(i + 1); loop(); }, autoplay); }
      car.addEventListener("mouseenter", function () { paused = true; }); car.addEventListener("mouseleave", function () { paused = false; });
      track.addEventListener("touchstart", function () { bump(); }, { passive: true });
      mark(); loop();
    });
  }

  /* -------------------------------------------- stock + dispatch urgency */
  function initUrgency() {
    var stockEls = []; /* astx: no simulated stock counter */ doc.querySelectorAll("[data-mv-stock]").forEach(function (e) { var r = e.closest(".mv-stock, [class*=stock]"); if (r) r.style.display = "none"; });
    if (stockEls.length) {
      /* v24: 23 down to 16, one every 40s, kept in sessionStorage so it never jumps back up while browsing */
      var TOP = 23, FLOOR = 16, STEP_MS = 40000, st = null;
      try { st = JSON.parse(sessionStorage.getItem("mv_stock_v4")); } catch (e) {}
      if (!st || !st.t) { st = { t: Date.now() }; try { sessionStorage.setItem("mv_stock_v4", JSON.stringify(st)); } catch (e) {} }
      var paintStock = function (bump) {
        var n = Math.max(FLOOR, TOP - Math.floor((Date.now() - st.t) / STEP_MS));
        stockEls.forEach(function (e) {
          if (e.textContent === String(n)) return;
          e.textContent = n;
          if (!bump) return;
          e.classList.remove("is-bump"); void e.offsetWidth; e.classList.add("is-bump");
        });
        return n;
      };
      if (paintStock(false) > FLOOR) {
        var stockTick = win.setInterval(function () { if (paintStock(true) <= FLOOR) win.clearInterval(stockTick); }, 1000);
      }
    }
    var shipEls = doc.querySelectorAll("[data-mv-ship]");
    if (shipEls.length) {
      var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      function fmt(d) { return DAY[d.getDay()] + " " + d.getDate() + " " + MON[d.getMonth()]; }
      function range(a, b) { return a.getMonth() === b.getMonth() ? a.getDate() + "–" + b.getDate() + " " + MON[a.getMonth()] : a.getDate() + " " + MON[a.getMonth()] + "–" + b.getDate() + " " + MON[b.getMonth()]; }
      function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
      function addWorking(d, n) { var x = new Date(d); while (n > 0) { x = addDays(x, 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
      function nextWorking(d) { var x = addDays(d, 1); while (x.getDay() === 0 || x.getDay() === 6) x = addDays(x, 1); return x; }
      function paintShip() {
        var now = new Date(), cut = new Date(); cut.setHours(15, 0, 0, 0); var dow = now.getDay(), txt;
        var dispatch = (dow >= 1 && dow <= 5 && now < cut) ? new Date(now) : nextWorking(now);
        if (dow === 0 || dow === 6) txt = "Order now — shipped " + DAY[dispatch.getDay()] + " · free UK delivery";
        else if (now < cut) { var left = cut - now, h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000); txt = "Order within " + (h > 0 ? h + "h " : "") + m + "m to ship today"; }
        else txt = "Order now — shipped " + DAY[dispatch.getDay()] + " morning";
        shipEls.forEach(function (e) { e.textContent = txt; });
        var shipped2 = nextWorking(dispatch), del1 = addWorking(now, 4), del2 = addWorking(now, 7);  /* 4-7 working days */
        doc.querySelectorAll("[data-ship-d0]").forEach(function (e) { e.textContent = fmt(now); });
        doc.querySelectorAll("[data-ship-d1]").forEach(function (e) { e.textContent = range(dispatch, shipped2); });
        doc.querySelectorAll("[data-ship-d2]").forEach(function (e) { e.textContent = range(del1, del2); });
      }
      paintShip(); setInterval(paintShip, 30000);
      doc.querySelectorAll(".mv-shipline .step").forEach(function (el, k) { el.style.setProperty("--i", k); });
    }
  }

  /* ------------------------------------------------------------ count-up */
  function initCountUp() {
    var els = doc.querySelectorAll("[data-mv-count]"); if (!els.length || reduced) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return; io.unobserve(x.target);
        var el = x.target, end = parseFloat(el.getAttribute("data-mv-count")), dec = (el.getAttribute("data-dec") | 0), suf = el.getAttribute("data-suf") || "", t0 = null, dur = 1400;
        function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = (dec === 0 ? Math.round(end * e).toLocaleString("en-GB") : (end * e).toFixed(dec)) + suf; if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* --------------------------------------------------- social-proof toast */
  function initToast() {
    return; /* astx: no fabricated purchase notifications */
    var t = doc.getElementById("mv-toast"); if (!t) return;
    var data = win.MV_TOAST || {}; var names = data.names || [], towns = data.towns || [], img = data.image || "";
    if (!names.length) return;
    if (store.get("mv_toast_off")) return;
    var nameEl = t.querySelector("[data-t-name]"), subEl = t.querySelector("[data-t-sub]"), im = t.querySelector("img");
    if (im && img) im.src = img;
    var bundles = []; /* weighted: 3-bottle most common */
    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
    function show() {
      var b = []; bundles.forEach(function (x) { for (var i = 0; i < x[1]; i++) b.push(x[0]); });
      var mins = 2 + Math.floor(Math.random() * 55);
      nameEl.textContent = pick(names) + " from " + pick(towns);
      subEl.innerHTML = "bought <em>" + pick(b) + "</em> of Magnavia · " + (mins < 60 ? mins + " min ago" : "1 hr ago");
      t.classList.add("is-show");
      setTimeout(function () { t.classList.remove("is-show"); }, 6500);
    }
    t.querySelector("button").addEventListener("click", function () { t.classList.remove("is-show"); store.set("mv_toast_off", 1); });
    setTimeout(function () { show(); setInterval(function () { if (doc.visibilityState === "visible") show(); }, 28000 + Math.random() * 12000); }, 11000);
  }

  /* ------------------------------------------- sign-up forms (code reveal) */
  /* Any form[data-mv-signup] posts to /contact in a hidden iframe so the page never reloads,
     then swaps to the success state showing the code. */
  function initSignup() {
    var forms = doc.querySelectorAll("form[data-mv-signup]"); if (!forms.length) return;
    var ifr = doc.getElementById("mv-signup-frame");
    if (!ifr) { ifr = doc.createElement("iframe"); ifr.id = "mv-signup-frame"; ifr.name = "mv-signup-frame"; ifr.style.cssText = "position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none"; ifr.setAttribute("aria-hidden", "true"); ifr.tabIndex = -1; doc.body.appendChild(ifr); }
    forms.forEach(function (f) {
      f.setAttribute("target", "mv-signup-frame");
      f.addEventListener("submit", function () {
        var email = f.querySelector("input[type=email]"); if (!email || !email.value) return;
        var box = f.closest("[data-mv-signup-box]") || f.parentNode;
        setTimeout(function () { box.classList.add("is-done"); store.set("mv_signed", { at: Date.now(), e: email.value }); }, 350);
      });
    });
    doc.querySelectorAll("[data-mv-copy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var code = b.getAttribute("data-mv-copy");
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { var o = b.textContent; b.textContent = "Copied!"; setTimeout(function () { b.textContent = o; }, 1600); });
      });
    });
  }

  /* --------------------------------------------------------------- quiz */
  function initQuiz() {
    var Q = win.MV_QUIZ; var ov = doc.getElementById("mvq-overlay"), box = doc.getElementById("mvq"); if (!Q || !ov || !box) return;
    var KEY = "mvq_state_v2", st = store.get(KEY) || {}, now = Date.now();
    var stage = doc.getElementById("mvq-stage"), prog = doc.getElementById("mvq-prog"), progWrap = doc.getElementById("mvq-prog-wrap"), title = doc.getElementById("mvq-title"), kick = doc.getElementById("mvq-kick");
    var picks = [], step = 0, opened = false, lastFocus = null;
    var esc = function (s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;"); };
    var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

    function renderQ() {
      var q = Q.questions[step];
      prog.style.width = Math.max(8, step / Q.questions.length * 100) + "%";
      kick.textContent = Q.kicker; title.textContent = Q.title;
      var h = '<p class="mvq-step">Question ' + (step + 1) + ' of ' + Q.questions.length + '</p><p class="mvq-q">' + esc(q.q) + '</p>';
      q.o.forEach(function (o) { h += '<button type="button" class="mvq-opt" data-t="' + esc(o[1]) + '"><i></i><span>' + esc(o[0]) + '</span></button>'; });
      h += '<button type="button" class="mvq-skip" id="mvq-later">' + esc(Q.skip) + '</button>';
      stage.innerHTML = h;
      stage.querySelectorAll(".mvq-opt").forEach(function (b) {
        b.addEventListener("click", function () {
          b.classList.add("is-picked"); picks.push(b.getAttribute("data-t")); step++;
          setTimeout(function () { if (step < Q.questions.length) renderQ(); else renderResult(); }, 260);
        });
      });
      doc.getElementById("mvq-later").addEventListener("click", snooze);
      var first = stage.querySelector(".mvq-opt"); if (first) first.focus();
    }
    function has(t) { return picks.indexOf(t) >= 0; }
    function renderResult() {
      prog.style.width = "100%"; progWrap.style.opacity = ".35";
      kick.textContent = Q.resultKicker; title.textContent = Q.resultTitle;
      var pains = [];
      if (has("night")) pains.push(Q.pains.night);
      if (has("legs") || has("wantcalm")) pains.push(Q.pains.legs);
      if (has("mind")) pains.push(Q.pains.mind);
      if (has("empty") || has("allday") || has("crash")) pains.push(Q.pains.empty);
      if (has("wired")) pains.push(Q.pains.wired);
      if (has("day")) pains.push(Q.pains.day);
      var why = has("failed") ? Q.whyFailed : has("first") ? Q.whyFirst : Q.whyDefault;
      var extra = (has("stomach") ? " " + Q.gentle : "") + (has("pills") ? " " + Q.pills : "");
      var lead = has("day") && !has("night") && !has("legs") && !has("mind") ? Q.leadDay : Q.leadNight;
      var h = '<span class="mvq-res-badge">' + ICON + ' ' + esc(Q.badge) + '</span>';
      if (pains.length) { h += '<ul class="mvq-pains">'; pains.slice(0, 3).forEach(function (p) { h += '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg><span>' + esc(p) + '</span></li>'; }); h += '</ul>'; }
      h += '<p class="mvq-res-p">' + lead + '</p><p class="mvq-res-p">' + why + extra + '</p><p class="mvq-res-p">' + Q.claims + '</p><p class="mvq-res-p"><b>' + esc(Q.guarantee) + '</b></p>';
      h += '<div id="mvq-offer"><p class="mvq-timer">' + esc(Q.offerLine) + '</p>'
        + '<form method="post" action="/contact#mvq" accept-charset="UTF-8" data-mv-signup id="mvq-form"><input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter,quiz,astaxanthin">'
        + '<input class="mvq-email" type="email" name="contact[email]" placeholder="' + esc(Q.emailPlaceholder) + '" required autocomplete="email">'
        + '<button class="mvq-cta" type="submit">' + esc(Q.emailCta) + '</button></form>'
        + '<a class="mvq-cta2" href="' + esc(Q.productUrl) + '">' + esc(Q.noThanks) + '</a></div>'
        + '<p class="mvq-small">' + esc(Q.small) + '</p>';
      stage.innerHTML = h;
      store.set(KEY, { done: true, at: now, picks: picks });
      var f = doc.getElementById("mvq-form");
      f.addEventListener("submit", function () {
        var email = f.querySelector("input[type=email]"); if (!email.value) return;
        setTimeout(function () {
          doc.getElementById("mvq-offer").innerHTML = '<div class="mvq-code"><small>' + esc(Q.codeLabel) + '</small><b>' + esc(Q.code) + '</b></div>'
            + '<a class="mvq-cta" href="/discount/' + encodeURIComponent(Q.code) + '?redirect=' + encodeURIComponent(Q.productUrl) + '">' + ICON + ' ' + esc(Q.claimCta) + '</a>'
            + '<button type="button" class="mvq-cta2" data-mv-copy="' + esc(Q.code) + '">' + esc(Q.copyLabel) + '</button>';
          initSignup();
        }, 350);
      });
      initSignup();
    }
    function open(reason) {
      if (opened) return;
      if (reason !== "manual") {
        var st2 = store.get(KEY) || {};
        if (st2.done || (st2.snoozeUntil && Date.now() < st2.snoozeUntil) || st2.shownThisLoad) return;
      }
      var st3 = store.get(KEY) || {}; st3.shownThisLoad = true; /* in-memory only */
      opened = true; lastFocus = doc.activeElement;
      ov.hidden = false; box.hidden = false;
      requestAnimationFrame(function () { ov.classList.add("is-show"); box.classList.add("is-show"); });
      renderQ(); store.set(KEY, Object.assign({}, st, { shownAt: now, reason: reason }));
    }
    function close() { ov.classList.remove("is-show"); box.classList.remove("is-show"); setTimeout(function () { ov.hidden = true; box.hidden = true; }, 380); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    function snooze() { var s = store.get(KEY) || {}; s.snoozeUntil = Date.now() + (Q.snoozeDays || 3) * 86400000; store.set(KEY, s); close(); /* opened stays true: one auto-show per page */ }
    doc.getElementById("mvq-x").addEventListener("click", function () { var s = store.get(KEY) || {}; if (s.done) close(); else snooze(); });
    ov.addEventListener("click", function () { var s = store.get(KEY) || {}; if (s.done) close(); else snooze(); });
    doc.addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) { var s = store.get(KEY) || {}; if (s.done) close(); else snooze(); } });
    /* manual triggers always work, even after snooze/done */
    doc.querySelectorAll("[data-mv-quiz-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); picks = []; step = 0; opened = false; progWrap.style.opacity = "1"; open("manual"); }); });
    var forced = /[?&]mvq=1/.test(location.search);
    if (!forced && (st.done || (st.snoozeUntil && now < st.snoozeUntil))) return;
    var delay = forced ? 300 : (Q.delayMs || 20000);
    setTimeout(function () { open("timer"); }, delay);
    /* exit intent (desktop): cursor leaves through the top edge */
    if (Q.exitIntent !== false) {
      var armed = false, exitShown = false; setTimeout(function () { armed = true; }, 6000);
      doc.addEventListener("mouseout", function (e) {
        if (!armed || opened || exitShown) return;
        var st4 = store.get(KEY) || {};
        if (st4.done || (st4.snoozeUntil && Date.now() < st4.snoozeUntil)) return;
        if (!e.relatedTarget && e.clientY <= 0) { exitShown = true; open("exit"); }
      });
    }
  }

  /* ---------------------------------------------- sticky-bar timer mirror */
  function initStickyTimer() {
    var t = doc.querySelector("[data-mv-sticky-timer]"); if (!t) return;
    var s = cdState();
    function paint() {
      var left = s.end - Date.now();
      if (left <= 0) { t.textContent = "Extended for you"; t.classList.add("is-extended"); return; }
      t.classList.remove("is-extended");
      var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), sec = Math.floor(left % 60000 / 1000);
      t.textContent = "ends in " + (h > 0 ? pad(h) + ":" : "") + pad(m) + ":" + pad(sec);
    }
    paint(); setInterval(function () { s = cdState(); paint(); }, 1000);
  }

  /* ------------------------------------------------ active footer links */
  function initActiveLinks() {
    var p = location.pathname.replace(/\/$/, "") || "/";
    doc.querySelectorAll(".mv-foot__col a").forEach(function (a) { var h = (a.getAttribute("href") || "").replace(/\/$/, "") || "/"; if (h === p) a.classList.add("is-active"); });
  }


  /* ------------------------------------------------- v5: marquee, explorers, motion */
  function initMarquee() {
    doc.querySelectorAll("[data-mv-marquee]").forEach(function (m) {
      m.addEventListener("touchstart", function () { m.classList.add("is-paused"); }, { passive: true });
      m.addEventListener("touchend", function () { setTimeout(function () { m.classList.remove("is-paused"); }, 3500); });
    });
  }
  function initForms() {
    doc.querySelectorAll("[data-mv-forms]").forEach(function (w) {
      var chips = w.querySelectorAll(".mv-forms__chip"), items = w.querySelectorAll(".mv-forms__item"), bar = w.querySelector(".mv-forms__bar i"),
          cycle = +(w.getAttribute("data-cycle") || 0), i = 0, timer, user = false;
      function show(k) {
        i = (k + chips.length) % chips.length;
        chips.forEach(function (c, j) { c.classList.toggle("is-on", j === i); c.setAttribute("aria-selected", j === i ? "true" : "false"); });
        items.forEach(function (it, j) { it.classList.toggle("is-on", j === i); });
        if (bar) { bar.style.transition = "none"; bar.style.width = "0"; void bar.offsetWidth; if (cycle && !user && !reduced) { bar.style.transition = "width " + cycle + "ms linear"; bar.style.width = "100%"; } }
      }
      function loop() { if (!cycle || user || reduced) return; clearTimeout(timer); timer = setTimeout(function () { if (doc.visibilityState === "visible") show(i + 1); loop(); }, cycle); }
      chips.forEach(function (c, k) { c.addEventListener("click", function () { user = true; clearTimeout(timer); show(k); }); });
      if ("IntersectionObserver" in win) { var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { show(i); loop(); io.disconnect(); } }); }, { threshold: 0.3 }); io.observe(w); } else { show(0); }
    });
  }
  function initSym() {
    doc.querySelectorAll("[data-mv-sym]").forEach(function (w) {
      var chips = w.querySelectorAll(".mv-sym__chip"), items = w.querySelectorAll(".mv-sym__item");
      chips.forEach(function (c, k) { c.addEventListener("click", function () {
        chips.forEach(function (x, j) { x.classList.toggle("is-on", j === k); x.setAttribute("aria-selected", j === k ? "true" : "false"); });
        items.forEach(function (it, j) { it.classList.toggle("is-on", j === k); });
      }); });
    });
  }
  function initTilt() {
    if (reduced || !(win.matchMedia && win.matchMedia("(hover:hover)").matches)) return;
    doc.querySelectorAll(".mv-tilt, .mv-bcard, .quantity-break, .mv-step").forEach(function (el) {
      el.addEventListener("pointermove", function (e) { var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5; el.style.transform = "perspective(700px) rotateX(" + (-y * 6).toFixed(2) + "deg) rotateY(" + (x * 6).toFixed(2) + "deg) translateY(-2px)"; });
      el.addEventListener("pointerleave", function () { el.style.transform = ""; });
    });
  }
  function initRipple() {
    return; /* astx: no expanding circle on click */
    if (reduced) return;
    doc.addEventListener("click", function (e) {
      var b = e.target.closest(".mv-btn, .product-form__submit, .atc-button"); if (!b) return;
      var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height), sp = doc.createElement("span"); sp.className = "mv-ripple";
      sp.style.cssText = "width:" + s + "px;height:" + s + "px;left:" + (e.clientX - r.left - s / 2) + "px;top:" + (e.clientY - r.top - s / 2) + "px";
      b.appendChild(sp); setTimeout(function () { sp.remove(); }, 650);
    });
  }
  function initProgress() {
    var bar = doc.createElement("div"); bar.className = "mv-progress"; doc.body.appendChild(bar);
    function paint() { var h = doc.documentElement.scrollHeight - win.innerHeight; bar.style.width = (h > 0 ? Math.min(100, win.scrollY / h * 100) : 0) + "%"; }
    win.addEventListener("scroll", paint, { passive: true }); paint();
  }

  /* ------------------------------------------------- v6 motion */
  function initSplit() {
    var h = doc.querySelector(".mv-hero__h1"); if (!h || reduced || h.getAttribute("data-split")) return;
    h.setAttribute("data-split", "1"); var i = 0, out = doc.createDocumentFragment();
    function wrap(txt, cls) { var w = doc.createElement("span"); w.className = "w"; var s = doc.createElement("span"); s.style.setProperty("--i", i++); if (cls) s.className = cls; s.textContent = txt; w.appendChild(s); return w; }
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) { n.textContent.split(/(\s+)/).forEach(function (t) { if (!t) return; if (/^\s+$/.test(t)) out.appendChild(doc.createTextNode(" ")); else out.appendChild(wrap(t)); }); }
      else if (n.nodeType === 1) { var em = n.cloneNode(false); em.appendChild(wrap(n.textContent)); out.appendChild(em); out.appendChild(doc.createTextNode(" ")); }
    });
    h.innerHTML = ""; h.appendChild(out);
  }
  function initMagnet() { /* disabled — cursor-follow on buttons read as vibration */ }

  function initParallax() {
    if (reduced || win.innerWidth < 900) return;
    var els = doc.querySelectorAll(".mv-forms__media img, .mv-auth__media img, .mv-offer__img img, .mv-step__media, .bbmt-media img, .bbcz-media img");
    if (!els.length) return; els.forEach(function (e) { e.setAttribute("data-mv-parallax", "1"); });
    var ticking = false;
    function paint() { ticking = false; var vh = win.innerHeight; els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; var c = (r.top + r.height / 2 - vh / 2) / vh; e.style.transform = "translateY(" + (-c * 22).toFixed(1) + "px)"; }); }
    win.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true }); paint();
  }
  function initGlow() {
    if (reduced || !(win.matchMedia && win.matchMedia("(hover:hover)").matches)) return;
    doc.querySelectorAll(".mv-offer").forEach(function (s) {
      s.addEventListener("pointermove", function (e) { var r = s.getBoundingClientRect(); s.style.setProperty("--mx", (e.clientX - r.left) + "px"); s.style.setProperty("--my", (e.clientY - r.top) + "px"); s.classList.add("is-hover"); });
      s.addEventListener("pointerleave", function () { s.classList.remove("is-hover"); });
    });
  }
  function initHeaderScroll() {
    function paint() { root.classList.toggle("mv-scrolled", win.scrollY > 24); }
    win.addEventListener("scroll", paint, { passive: true }); paint();
  }
  function initPricePop() {
    doc.addEventListener("mv:bundle", function (e) { var p = e.target.querySelector("[data-mv-atc-price]"); if (!p) return; p.classList.remove("mv-pop"); void p.offsetWidth; p.classList.add("mv-pop"); });
  }
  function initIndexVars() {
    doc.querySelectorAll(".mv-benefits li, .mv-chiprow span, .mv-stats__grid li, .bbrv-row, .mv-foot__col").forEach(function (el) { var k = Array.prototype.indexOf.call(el.parentNode.children, el); el.style.setProperty("--i", k); });
    doc.querySelectorAll(".mv-benefits .ic svg, .mv-chiprow svg").forEach(function (el, k) { el.style.setProperty("--i", k % 4); });
  }

  /* ------------------------------------------------- shipping protection toggle */
  doc.addEventListener("click", function (e) {   /* promo code: copy only — never auto-applied, the customer enters it at checkout */
    var btn = e.target.closest ? e.target.closest("[data-mv-promo]") : null; if (!btn) return;
    var code = btn.getAttribute("data-mv-promo"), lab = btn.querySelector("[data-mv-promo-label]") || btn;
    if (btn.classList.contains("is-copied")) return;
    var flash = function () {
      var was = lab.textContent; lab.textContent = "Copied"; btn.classList.add("is-copied");
      setTimeout(function () { lab.textContent = was; btn.classList.remove("is-copied"); }, 1600);
    };
    var manual = function () {
      var ta = doc.createElement("textarea"); ta.value = code; ta.setAttribute("readonly", ""); ta.style.cssText = "position:fixed;top:0;left:0;opacity:0";
      doc.body.appendChild(ta); ta.select();
      try { if (doc.execCommand("copy")) flash(); } catch (err) {}
      doc.body.removeChild(ta);
    };
    if (win.navigator && navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(flash, manual);
    else manual();
  });
  function initProtect() {
    /* Protection is a hidden cart line. It only ever sits next to a real item: with an empty cart the switch just
       remembers the choice (localStorage), the line is added with the first bottle and removed if left on its own. */
    var busy = false, KEY = "mv_protect_want";
    function pvid() { var e = doc.querySelector("[data-mv-protect]"); return e ? String(e.getAttribute("data-variant")) : ""; }
    function paint(on) {
      doc.querySelectorAll("[data-mv-protect]").forEach(function (e) {
        var b = e.querySelector("input"); if (b) b.checked = on; e.classList.toggle("is-on", on);
      });
    }
    function post(url, body) { return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }); }
    function state(c, v) {
      return { hasP: c.items.some(function (i) { return String(i.variant_id) === v; }), real: c.items.filter(function (i) { return String(i.variant_id) !== v; }).length };
    }
    function after() { if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; } refresh(); }
    function refresh() {
      /* re-render the drawer from the server: the theme's own partial re-render collapses the item table */
      var host = doc.getElementById("shopify-section-cart-drawer"); if (!host) return sync();
      var path = location.pathname === "/" ? "/" : location.pathname;
      fetch(path + "?sections=cart-drawer").then(function (r) { return r.json(); }).then(function (j) {
        var html = j["cart-drawer"]; if (!html) return sync();
        var tmp = doc.createElement("div"); tmp.innerHTML = html;
        var fresh = tmp.querySelector("#shopify-section-cart-drawer") || tmp.firstElementChild; if (!fresh) return sync();
        var cur = host.querySelector("cart-drawer, .cart-drawer, #CartDrawer");
        var keep = cur ? cur.className : null;
        host.innerHTML = fresh.innerHTML;
        var next = host.querySelector("cart-drawer, .cart-drawer, #CartDrawer");
        if (next && keep) next.className = keep;   /* keep the drawer open */
        sync();
      }).catch(function () { sync(); });
    }
    function sync() {
      var v = pvid(); if (!v) return;
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
        var s = state(c, v), saved = store.get(KEY), want = saved === 1 || (saved == null && s.hasP && s.real > 0);
        paint(want);
        if (busy) return;
        if (s.real === 0 && s.hasP) { busy = true; post("/cart/change.js", { id: v, quantity: 0 }).then(function () { busy = false; after(); }, function () { busy = false; }); }
        else if (s.real > 0 && want && !s.hasP) { busy = true; post("/cart/add.js", { id: +v, quantity: 1 }).then(function () { busy = false; after(); }, function () { busy = false; }); }
      }).catch(function () {});
    }
    /* delegated: the cart drawer re-renders after every cart change, so per-element listeners die */
    doc.addEventListener("change", function (ev) {
      var box = ev.target; if (!box || box.type !== "checkbox") return;
      var el = box.closest ? box.closest("[data-mv-protect]") : null; if (!el) return;
      if (busy) { box.checked = !box.checked; return; }
      var on = box.checked, v = String(el.getAttribute("data-variant"));
      store.set(KEY, on ? 1 : 0); paint(on); busy = true;
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
        var s = state(c, v), done = function () { busy = false; if (el.getAttribute("data-reload")) { location.reload(); return; } after(); };
        if (on && s.real > 0 && !s.hasP) return post("/cart/add.js", { id: +v, quantity: 1 }).then(done, done);
        if (!on && s.hasP) return post("/cart/change.js", { id: v, quantity: 0 }).then(done, done);
        busy = false;   /* empty cart: nothing to protect yet, the choice is applied with the first bottle */
      }).catch(function () { busy = false; });
    });
    sync();
    doc.addEventListener("click", function (ev) {   /* drawer opens or a bottle is added: re-sync */
      if (ev.target.closest && ev.target.closest("[data-mv-protect]")) return;
      setTimeout(sync, 600);
      if (ev.target.closest && ev.target.closest(".product-form__submit, button[name=add], .atc-button")) setTimeout(sync, 2400);
    }, true);
  }

  /* --------------------------------------- "Offer" line-item property (shows the deal at checkout) */
  function offerText(title, price, compare) {
    price = +price; compare = +compare;
    if (!compare || compare <= price) return "";
    var save = ((compare - price) / 100), pct = Math.round(100 - price * 100 / compare);
    var deal = /\(([^)]+)\)/.exec(title || "");
    return (deal ? deal[1] + " — " : "") + "you save " + money(compare - price) + " (" + pct + "% off)";
  }
  function initOfferProps() { /* replaced by groomOffers — form-level property inputs trip the theme's
     custom-field validation and disable the ATC, so the Offer property is stamped post-add instead. */ }

  /* cart groomer: guarantee the Offer property on bundle lines no matter how they were added */
  function groomOffers() {
    if (BUNDLE_MODE === "quantity") return;   /* the automatic Buy-X-get-Y discount already shows the deal at checkout */
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      var need = c.items.filter(function (i) { return i.product_handle === "astaxanthin" && !(i.properties && i.properties.Offer); });
      if (!need.length) return;
      fetch("/products/astaxanthin.js").then(function (r) { return r.json(); }).then(function (pd) {
        var map = {}; pd.variants.forEach(function (v) { map[v.id] = v; });
        var chain = Promise.resolve();
        need.forEach(function (item) {
          var v = map[item.variant_id]; if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return;
          var txt = offerText(v.title, v.price, v.compare_at_price); if (!txt) return;
          chain = chain.then(function () {
            return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { Offer: txt } }) });
          });
        });
      });
    }).catch(function () {});
  }
  /* stamp the Offer property at add time by wrapping fetch for /cart/add (no DOM inputs —
     those trip the theme's custom-field validation) */
  (function () {
    if (BUNDLE_MODE === "quantity") return;   /* the automatic tier discount shows the deal at checkout; no line-item property needed */
    var VMAP = null, loading = null, of = win.fetch;
    function vmap() {
      if (VMAP) return Promise.resolve(VMAP);
      loading = loading || of.call(win, "/products/astaxanthin.js").then(function (r) { return r.json(); }).then(function (pd) {
        VMAP = {}; pd.variants.forEach(function (v) { VMAP[v.id] = v; }); return VMAP;
      }).catch(function () { VMAP = {}; return VMAP; });
      return loading;
    }
    win.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (url.indexOf("/cart/add") >= 0 && init && init.body) {
          return vmap().then(function (m) {
            try {
              if (init.body instanceof FormData) {
                var id = +init.body.get("id"), v = m[id];
                if (v && v.compare_at_price > v.price && !init.body.get("properties[Offer]")) init.body.append("properties[Offer]", offerText(v.title, v.price, v.compare_at_price));
              } else if (typeof init.body === "string" && init.body.charAt(0) === "{") {
                var d = JSON.parse(init.body);
                var apply = function (it) { var v = m[+it.id]; if (v && v.compare_at_price > v.price) { it.properties = it.properties || {}; if (!it.properties.Offer) it.properties.Offer = offerText(v.title, v.price, v.compare_at_price); } };
                if (d.items) d.items.forEach(apply); else if (d.id) apply(d);
                init.body = JSON.stringify(d);
              }
            } catch (e) {}
            return of.call(win, input, init).then(function (res) {
              try { if (false && res && res.ok && win.maybeProtectPopupT === undefined) { win.maybeProtectPopupT = 1; setTimeout(function () { win.maybeProtectPopupT = undefined; maybeProtectPopup(); }, 1400); } } catch (e) {}
              return res;
            });
          });
        }
      } catch (e) {}
      return of.call(win, input, init);
    };
  })();

  /* protection upsell popup: once per session, after the product lands in the cart */
  function maybeProtectPopup() {
    try { if (sessionStorage.getItem("mv_pp")) return; } catch (e) {}
    var vid = null, el = doc.querySelector("[data-mv-protect]");
    vid = el ? el.getAttribute("data-variant") : "54197933408539";
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items.length) return;
      if (c.items.some(function (i) { return String(i.variant_id) === String(vid); })) { try { sessionStorage.setItem("mv_pp", "1"); } catch (e) {} return; }
      if (doc.getElementById("mv-pp")) return;
      var d = doc.createElement("div"); d.id = "mv-pp"; d.setAttribute("role", "dialog"); d.setAttribute("aria-label", "Add shipping protection");
      d.innerHTML = '<div class="mv-pp__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg></div>'
        + '<div class="mv-pp__t"><b>Protect your order — £2.99</b><span>Instant replacement or refund if it\u2019s lost, stolen or damaged in transit.</span></div>'
        + '<div class="mv-pp__b"><button type="button" class="mv-btn" data-pp-add>Add protection</button><button type="button" class="mv-pp__no" data-pp-no>No thanks</button></div>';
      doc.body.appendChild(d);
      requestAnimationFrame(function () { d.classList.add("is-show"); });
      function goAway() { d.classList.remove("is-show"); setTimeout(function () { d.remove(); }, 400); try { sessionStorage.setItem("mv_pp", "1"); } catch (e) {} }
      d.querySelector("[data-pp-no]").addEventListener("click", goAway);
      d.querySelector("[data-pp-add]").addEventListener("click", function () {
        var b = d.querySelector("[data-pp-add]"); b.textContent = "Adding…"; b.disabled = true;
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: +vid, quantity: 1 }) }).then(function () {
          b.textContent = "✓ Protected"; doc.querySelectorAll("[data-mv-protect]").forEach(function (e) { e.classList.add("is-on"); var i = e.querySelector("input"); if (i) i.checked = true; });
          setTimeout(goAway, 1200);
        });
      });
      setTimeout(function () { if (doc.getElementById("mv-pp")) goAway(); }, 16000);
    }).catch(function () {});
  }
  function initPreselect() {
    /* Preselect "Most Popular" AFTER the theme's variant machinery is ready, and never
       override a choice the user has already made. */
    if (/[?&]variant=/.test(location.search)) return;
    var attempts = 0, userTouched = false;
    doc.addEventListener("pointerdown", function (e) { if (e.target.closest(".quantity-breaks-container")) userTouched = true; }, true);
    function btn() { return doc.querySelector(".main-product-atc"); }
    function healthy() { var b = btn(); return b && !b.disabled && b.getAttribute("data-unavailable") !== "true"; }
    function attempt() {
      if (userTouched) return;
      var inputs = doc.querySelectorAll(".quantity-breaks-container input[type=radio]");
      if (inputs.length < 2) return;
      var cur = Array.prototype.findIndex.call(inputs, function (i) { return i.checked; });
      if (cur > 0) return;                      /* already moved off the default — leave it */
      inputs[1].click();
      setTimeout(function () {
        if (healthy() || attempts >= 3 || userTouched) {
          if (!healthy() && btn() && /add to cart/i.test(btn().textContent)) { btn().disabled = false; btn().removeAttribute("data-unavailable"); }
          return;
        }
        attempts++;
        inputs[0].click();
        setTimeout(function () { if (!userTouched) { inputs[1].click(); setTimeout(attempt, 800); } }, 300);
      }, 900);
    }
    if (doc.readyState === "complete") setTimeout(attempt, 800);
    else win.addEventListener("load", function () { setTimeout(attempt, 800); });
  }
  /* ------------------------------------------ v11 motion: timeline fill + staggered grids */
  function initMotionV11() {
    var groups = doc.querySelectorAll(".mv-inside__grid, .mv-helps, .mv-sym__chips");
    groups.forEach(function (e) { e.classList.add("mv-reveal", "mv-reveal--stagger"); });
    var tracks = doc.querySelectorAll(".mv-expect__track, .bb-sec .bbst-grid"), steps = doc.querySelectorAll(".mv-expect__step, .bbst-card");
    if (reduced || !("IntersectionObserver" in win)) {
      groups.forEach(function (e) { e.classList.add("is-in"); }); steps.forEach(function (e) { e.classList.add("is-in"); });
      tracks.forEach(function (t) { t.style.setProperty("--p", "1"); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("is-in"); io.unobserve(x.target); } });
    }, { threshold: 0.18, rootMargin: "0px 0px -50px 0px" });
    groups.forEach(function (e) { io.observe(e); }); steps.forEach(function (e) { io.observe(e); });
    if (!tracks.length) return;
    var ticking = false;
    function paint() {
      ticking = false; var mid = win.innerHeight * 0.55;
      tracks.forEach(function (t) {
        var r = t.getBoundingClientRect(), p = Math.max(0, Math.min(1, (mid - r.top) / Math.max(1, r.height)));
        t.style.setProperty("--p", p.toFixed(3));
        t.querySelectorAll(".mv-expect__step, .bbst-card").forEach(function (s) {
          var sr = s.getBoundingClientRect(); s.classList.toggle("is-active", sr.top < mid && sr.bottom > mid - 40);
        });
      });
    }
    function onScroll() { if (!ticking) { ticking = true; win.requestAnimationFrame(paint); } }
    win.addEventListener("scroll", onScroll, { passive: true }); win.addEventListener("resize", onScroll); paint();
  }

  /* ----------------------------------- v21: cart bundle lines show bottles while + / - change whole bundles */
  function initBundleQty() {
    doc.addEventListener("change", function (ev) {
      var i = ev.target; if (!i || !i.matches || !i.matches(".quantity__input[data-mv-pack]")) return;
      var s = i.parentElement && i.parentElement.querySelector(".mv-qty-bottles"); if (!s) return;
      s.textContent = (parseInt(i.value, 10) || 0) * (parseInt(i.getAttribute("data-mv-pack"), 10) || 1);
    }, true);
  }

  /* ------------------------------------- v25: the sticky bar follows the chosen bundle */
  function initStickyBundle() {
    var map = {}, deal = null, dealText = "", last = null, want = null;
    doc.querySelectorAll('script[type="application/json"]').forEach(function (s) {
      if (Object.keys(map).length) return;
      try { var j = JSON.parse(s.textContent); if (Array.isArray(j) && j[0] && j[0].id && j[0].price !== undefined) j.forEach(function (v) { map[v.id] = v; }); } catch (e) {}
    });
    if (!Object.keys(map).length) return;
    function paint() {   /* self-healing: the theme re-renders the bar on every variant change, so look it up each time */
      var bar = doc.querySelector("sticky-atc"); if (!bar) return;
      var host = bar.querySelector(".sticky-atc__left__content"), img = bar.querySelector(".sticky-atc__image img");
      if (!host) return;
      if (!deal || !host.contains(deal)) {
        deal = host.querySelector(".mv-sticky-deal");
        if (!deal) {
          deal = doc.createElement("span"); deal.className = "mv-sticky-deal"; deal.hidden = true;
          var t = host.querySelector(".sticky-atc__title");
          host.insertBefore(deal, t ? t.nextSibling : host.firstChild);
        }
      }
      var sec = bar.closest(".shopify-section") || doc;
      var el = sec.querySelector("input[name='id'].product-variant-id") || doc.querySelector("input[name='id'].product-variant-id");
      var id = el && el.value;
      if (id && id !== last) {
        last = id;
        var v = map[id];
        if (v) {
          want = v.featured_image && v.featured_image.src ? v.featured_image.src.split("?")[0] + "?width=300" : null;
          var save = v.compare_at_price > v.price ? Math.round(100 - v.price * 100 / v.compare_at_price) : 0;
          dealText = v.title + (save ? " \u00b7 SAVE " + save + "%" : "");
          if (img && want) img.alt = v.name || v.title;
        }
      }
      if (dealText && deal.textContent !== dealText) deal.textContent = dealText;
      if (dealText) deal.hidden = false;
      if (img && want && img.getAttribute("src") !== want) img.setAttribute("src", want);
    }
    paint();
    doc.addEventListener("click", function () { win.setTimeout(paint, 250); }, true);
    doc.addEventListener("change", function () { win.setTimeout(paint, 250); }, true);
    win.setInterval(paint, 500);
  }

  ready(function () {
    initPreselect(); /* open on Most Popular; the other quantity-mode code stays off */ initIndexVars(); initReveal(); initMotionV11(); initCountdown(); initStickyTimer(); initBundles(); initCarousel(); initUrgency(); initCountUp(); initToast(); initSignup(); initQuiz(); initActiveLinks(); initMarquee(); initForms(); initSym(); initTilt(); initRipple(); initProgress(); initIndexVars(); initSplit(); initMagnet(); initParallax(); initGlow(); initHeaderScroll(); initPricePop(); initProtect(); initBundleQty(); initStickyBundle(); initOfferProps(); groomOffers(); doc.addEventListener("click", function (e) { if (e.target.closest(".product-form__submit, .atc-button")) { setTimeout(groomOffers, 2200); setTimeout(groomOffers, 4500); } });
  });
  doc.addEventListener("shopify:section:load", function () { initBundles(); initCarousel(); initCountdown(); initSignup(); initForms(); initSym(); initMarquee(); });
})();

/* === MAGNAVIA-UI-JS === */
/* === MAGNAVIA-GEO === */
/* This is a UK-only store, but the shop's PRIMARY market is still United States and the
   General delivery profile only has a GB zone — so a visitor resolved into the US market
   sees "sold out" and a fallback shipping charge. Force the GB market once per visitor.
   Remove this block if United Kingdom is ever made the primary market in Admin. */
(function(){
  try{
    if (window.Shopify && window.Shopify.country === 'GB') return;
    if (sessionStorage.getItem('mv_geo_gb') === '1') return;
    sessionStorage.setItem('mv_geo_gb','1');
    var f = document.createElement('form');
    f.method = 'POST'; f.action = '/localization'; f.style.display = 'none';
    [['form_type','localization'],['_method','put'],['country_code','GB'],
     ['return_to', window.location.pathname + window.location.search]].forEach(function(kv){
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
    });
    document.body.appendChild(f); f.submit();
  }catch(e){}
})();

(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = '.mv-card,.bb-card,.mv-bundles__card,.mv-stat,.mv-helps li';
  function mark(){
    document.querySelectorAll(sel).forEach(function(el){ el.classList.add('mv-reveal'); });
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e,i){
        if(!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function(){ el.classList.add('is-in'); }, Math.min(i*55, 280));
        io.unobserve(el);
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:.08});
    document.querySelectorAll('.mv-reveal').forEach(function(el){ io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark);
  else mark();
  // safety net: never leave content invisible if the observer is slow or unsupported
  setTimeout(function(){ document.querySelectorAll('.mv-reveal').forEach(function(el){ el.classList.add('is-in'); }); }, 2500);
})();

/* === MAGNAVIA-MOTION === */
(function () {
  var RM = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  function onView(el, fn) {
    if (!("IntersectionObserver" in window)) return fn();
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); fn(); } }, { rootMargin: "0px 0px -15% 0px" });
    io.observe(el);
  }
  function rep() {
    var sec = document.querySelector(".mv-rep"); if (!sec || sec.getAttribute("data-mv-rep")) return;
    sec.setAttribute("data-mv-rep", "1");
    var ns = [].slice.call(sec.querySelectorAll(".mv-rep__n"));
    ns.forEach(function (n, i) {
      var m = n.textContent.trim().match(/^([\d.]+)(.*)$/); if (!m) return;
      n._end = parseFloat(m[1]); n._dec = (m[1].split(".")[1] || "").length; n._suf = m[2];
      n.setAttribute("aria-label", n.textContent.trim());
      var li = n.closest("li"); li.style.setProperty("--i", i);
      var bar = document.createElement("i"); bar.className = "mv-rep__bar"; bar.setAttribute("aria-hidden", "true");
      bar.style.setProperty("--w", (n._suf === "%" ? n._end : n._end <= 5 ? n._end / 5 * 100 : 100) + "%");
      li.appendChild(bar);
    });
    if (RM) return;
    sec.classList.add("mv-rep--js");
    ns.forEach(function (n) { if (n._end != null) n.textContent = (0).toFixed(n._dec) + n._suf; });
    onView(sec.querySelector("ul") || sec, function () {
      sec.classList.add("is-counted");
      ns.forEach(function (n, i) {
        if (n._end == null) return;
        setTimeout(function () {
          var t0 = null, dur = 1600;
          function st(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
            n.textContent = (n._end * e).toFixed(n._dec) + n._suf;
            if (p < 1) requestAnimationFrame(st); else n.classList.add("is-done"); }
          requestAnimationFrame(st);
        }, 150 + i * 80);
      });
    });
  }
  function reviews() {
    var s = document.querySelector(".mvrs"); if (!s) return;
    if (RM) return s.classList.add("is-in");
    onView(s, function () { s.classList.add("is-in"); });
  }
  function perBottle() {
    var cards = document.querySelectorAll(".quantity-break"), best = null, min = 1e9;
    cards.forEach(function (c) {
      var lab = c.querySelector(".quantity-break__label-text"), pr = c.querySelector(".quantity-break__price"), right = c.querySelector(".quantity-break__right");
      if (!lab || !pr || !right) return;
      var t = lab.textContent.replace(/\s+/g, " ").trim(), m = t.match(/buy\s+(\d+)(?:\s+get\s+(\d+))?/i);
      var price = parseFloat((pr.textContent.match(/[\d,]+\.\d\d/) || ["0"])[0].replace(",", ""));
      var pm = t.match(/(\d+)\s*pouch/i);
      var n = m ? (+m[1]) + (+(m[2] || 0)) : (pm ? +pm[1] : 0);
      if (!n || !price) return;
      var each = price / n;
      var el = right.querySelector(".mv-perbottle");
      if (!el) { el = document.createElement("span"); el.className = "mv-perbottle"; right.appendChild(el); }
      el.textContent = "£" + each.toFixed(2) + " / pouch"; el.classList.remove("mv-perbottle--best");
      if (n > 1 && each < min) { min = each; best = el; }
    });
    if (best) best.classList.add("mv-perbottle--best");
  }
  function cartEta() {
    // delivery box keeps its original single line ("Free UK delivery · estimated 5–8 business days");
    // drop any previously-injected delivery-date line
    document.querySelectorAll(".mv-cart-eta__date").forEach(function (el) { el.remove(); });
  }
  function boot() { rep(); reviews(); perBottle(); setTimeout(perBottle, 1500); cartEta(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("change", function (e) { if (e.target.closest && e.target.closest(".quantity-breaks")) setTimeout(perBottle, 300); });
  // cart drawer re-renders on open — make sure no stale delivery-date line lingers
  var _et; new MutationObserver(function () { clearTimeout(_et); _et = setTimeout(cartEta, 120); })
    .observe(document.body, { childList: true, subtree: true });
})();
